import {
  convertUTCStringToLocalTime,
  getIANAtimeZone,
} from "@/assignments/utils/dateUtils";
import { Assignment } from "@/types/models/Assignment.interface";

const getHasTitle = (assignment: Assignment) => assignment?.title?.length > 0;

export const getHasAssignees = (assignment: Assignment) =>
  !!assignment?.assignment_classrooms?.length ||
  !!assignment?.assignment_groups?.length;

const isScheduleDateValid = (
  assignment: Assignment,
  maxScheduleDate?: string,
) => {
  return (
    !maxScheduleDate ||
    (assignment?.date_goes_live !== null &&
      assignment?.date_goes_live < maxScheduleDate)
  );
};

const getErrors = (assignment: Assignment, maxScheduleDate?: string) => {
  return {
    noAssignees: !getHasAssignees(assignment),
    noTitle: !getHasTitle(assignment),
    hasInvalidDate: !isScheduleDateValid(assignment, maxScheduleDate),
  };
};

export const getIsAssignmentValid = (
  assignment: Assignment,
  isDraftSave: boolean,
  maxScheduleDate?: string,
) => {
  const errors = getErrors(assignment, maxScheduleDate);
  const { noTitle, noAssignees, hasInvalidDate } = errors;

  if (isDraftSave) return !noTitle;

  return !noTitle && !noAssignees && !hasInvalidDate;
};

const getInvalidFieldMessage = (
  noTitle: boolean,
  noAssignees: boolean,
  hasInvalidDate: boolean,
  maxScheduleDate: string,
) => {
  const formattedExpirationDate = convertUTCStringToLocalTime(
    maxScheduleDate,
    getIANAtimeZone(),
    "MM/DD/YYYY",
  );

  if (noTitle) {
    return "add a title";
  }

  if (noAssignees) {
    return "add an assignee";
  }

  if (hasInvalidDate) {
    return `update the schedule for later date to before ${formattedExpirationDate}`;
  }

  return "";
};

export const getInvalidAssignmentMessage = (
  assignment: Assignment,
  isPublishedAssignment: boolean,
  maxScheduleDate: string,
) => {
  const errors = getErrors(assignment, maxScheduleDate);
  const { noTitle, noAssignees, hasInvalidDate } = errors;

  const invalidFieldMessage = getInvalidFieldMessage(
    noTitle,
    noAssignees,
    hasInvalidDate,
    maxScheduleDate,
  );

  const numOfErrors = Object.values(errors).filter((error) => error).length;

  const action = isPublishedAssignment ? "save" : "create";

  if (numOfErrors > 1) {
    return `Please fix ${numOfErrors} errors to ${action} your assignment`;
  }

  if (invalidFieldMessage) {
    return `Please ${invalidFieldMessage} to ${action} this assignment`;
  }
  return "";
};
